import React from 'react';
import PropTypes from 'prop-types';
import ContentAdd from '@material-ui/icons/Add';
import { Link } from 'react-router-dom';
import { Button, Responsive, translate } from 'react-admin';
import MuiButton from '@material-ui/core/Button';
import classnames from 'classnames';
import onlyUpdateForKeys from 'recompose/onlyUpdateForKeys';
import { withStyles, createStyles, Theme } from '@material-ui/core/styles';
import compose from 'recompose/compose';
import Fab from '@material-ui/core/Fab';

const styles = ((theme: Theme) => createStyles({
    floating: {
        color: theme.palette.getContrastText(theme.palette.primary.main),
        margin: 0,
        top: 'auto',
        right: 20,
        bottom: 60,
        left: 'auto',
        position: 'fixed',
        zIndex: 1000,
    },
    floatingLink: {
        color: 'inherit',
    },
}));

const omitId = ({ id, ...rest }) => rest;

export const CreateButton = ({
    basePath = '',
    label = 'ra.action.create',
    record,
    translate,
    classes,
    className,
    icon = <ContentAdd />,
    ...rest
}) => (
    <Responsive
        small={
            <Fab
                component={Link}
                color="primary"
                className={classnames(classes.floating, className)}
                to={{
                    pathname: `${basePath}/create`,
                    state: { record: omitId(record) },
                }}
                aria-label={label && translate(label)}
                {...rest}
            >
                {icon}
            </Fab>
        }
        medium={
            <Button
                component={Link}
                to={{
                    pathname: `${basePath}/create`,
                    state: { record: omitId(record) },
                }}
                className={className}
                label={label}
                {...rest}
            >
                {icon}
            </Button>
        }
    />
);

CreateButton.propTypes = {
    basePath: PropTypes.string,
    className: PropTypes.string,
    classes: PropTypes.object,
    label: PropTypes.string,
    record: PropTypes.object,
    icon: PropTypes.element,
};

const enhance = compose(
    translate,
    onlyUpdateForKeys(['basePath', 'label', 'translate']),
    withStyles(styles)
);

export default enhance(CreateButton);